<template>
  <div class="orangTree">
    <IviewButton type='primary' @click="setNode" class="btn">设置节点</IviewButton>
    <IviewTable :data="tableData" :columns="tableCol" :page="pager" @on-page-change="changePageSize"> </IviewTable>
    <IviewModal v-model="nodePopup" title="设置节点" @on-ok="setNodeConfirm">
      <div class="node-content">
        <div class="form-item">
          <div class="label">所属项目 :</div>
          <span>{{ $root.platform || '-' }}</span>
        </div>
        <div class="form-item person-cao" v-for="(item, i) in nodeList" :key="i">
          <div class="label">{{ i + 1 }}级组织 :</div>
          <IviewInput v-model="item.orgLevelName" placeholder="请输入组织名称" />
          <img class="img1" @click="addItem(i)" src="~_img/common/table-add.png" alt="" />
          <img
            class="img2"
            @click="delItem(i)"
            v-show="nodeList.length - 1 == i && item.groupNums == 0"
            src="~_img/common/table-del.png"
            alt=""
          />
        </div>
      </div>
    </IviewModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableCol: [
        { title: '组织树节点', key: 'orgLevel', align: 'center' },
        { title: '节点别名', key: 'orgLevelName', align: 'center' },
        { title: '更新时间', key: 'updateTime', align: 'center' }
      ],
      nodePopup: false,
      pager: {
        total: 0
      },
      nodeList: [{ orgLevelName: '' }]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.config.getNode().then((res) => {
        this.tableData = res.data
      })
    },
    // 添加删除输入框项
    addItem(i, val) {
      this.nodeList.splice(i + 1, 0, {
        orgLevelName: ''
      })
    },
    delItem(i, val) {
      this.nodeList.splice(i, 1)
    },
    setNode() {
      this.nodePopup = true
      if (this.tableData.length == 0) {
        this.nodeList = [{ orgLevelName: '' }]
      } else {
        this.nodeList = [...this.tableData]
      }
    },
    setNodeConfirm() {
      let arr = this.nodeList.map((item, i) => ({ orgLevelName: item.orgLevelName, orgLevel: i + 1 }))
      this.$api.config.putNode(arr).then((res) => {
        this.getList()
        this.$Message.success('操作成功')
        this.nodePopup = false
      })
    },
    changePageSize(e) {}
  }
}
</script>

<style lang="less" scoped>
.orangTree {
  .btn {
    margin-bottom: 20px;
  }
  .node-content {
    .form-item {
      display: flex;
      align-items: center;
      margin: 20px 0 0 100px;
      font-size: 14px;

      .label {
        width: 100px;
        text-align: right;
        margin-right: 8px;
      }
    }
  }
  .person-cao {
    .img1,
    .img2 {
      width: 16px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  /deep/.i-table {
    .i-page {
      display: none;
    }
  }
}
</style>
